import PropTypes from 'prop-types'
import { PureComponent } from 'react'

import { cn } from '@repo/utils'

import { IMAGE_SIZES } from '../../constants'
import Image, { ImageDefaultProps, ImagePropTypes } from '../Image'

import styles from './index.css'

const imageVariant = (displayName, props) => {
  class Avatar extends PureComponent {
    render() {
      const { size } = this.props
      const style = {}
      if (size) {
        style.fontSize = size
      }

      return (
        <Image
          {...this.props}
          className={cn(styles.default, this.props.className)}
          wrapperStyle={{ ...this.props.wrapperStyle, ...style }}
        />
      )
    }
  }

  Avatar.displayName = displayName

  Avatar.propTypes = {
    ...ImagePropTypes,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }

  Avatar.defaultProps = {
    ...ImageDefaultProps,
    size: null,
    ...props,
  }

  return Avatar
}

export const Avatar = imageVariant('Avatar', {
  fallbackIconName: 'user outline',
  srcImageSize: IMAGE_SIZES.FIT_45_45,
})

export const Shield = imageVariant('Shield', {
  fallbackIconName: 'shield',
  srcImageSize: IMAGE_SIZES.FIT_45_45,
})

export const Trophy = imageVariant('Trophy', {
  fallbackIconName: 'trophy',
  srcImageSize: IMAGE_SIZES.FIT_45_45,
})

export const Build = imageVariant('Build', {
  fallbackIconName: 'building outline',
  srcImageSize: IMAGE_SIZES.FIT_45_45,
})
